import { itx } from "../../translationItx/itx";
import type BaseModel from "../../models/BaseModel";
import type { SecondaryNavigatorTarget } from "./TreeContext";

export function secondaryNavigatorTarget(object: BaseModel): SecondaryNavigatorTarget | undefined {
  return object === state.cabinets
    ? "cabinets" // no itx
    : object === state.sceneGroup
      ? "scenes" // no itx
      : object === state.addresses
        ? "addresses" // no itx
        : object === state.topologies
          ? "topologies" // no itx
          : object === state.templateGroups
            ? "products" // no itx
            : undefined;
}

/** Opens a project branch below without selecting or expanding the row. */
export default function NavigatorBranchButton({ target, onOpen }: {
  target: SecondaryNavigatorTarget;
  onOpen: (target: SecondaryNavigatorTarget) => void;
}) {
  const labels: Record<SecondaryNavigatorTarget, string> = {
    cabinets: itx("navigator.openCabinetsBelow", "Schaltschränke im unteren Navigator öffnen"),
    scenes: itx("navigator.openScenesBelow", "Szenen im unteren Navigator öffnen"),
    addresses: itx("navigator.openAddressesBelow", "Gruppenadressen im unteren Navigator öffnen"),
    topologies: itx("navigator.openTopologiesBelow", "Topologie im unteren Navigator öffnen"),
    products: itx("navigator.openProductsBelow", "Produkte im unteren Navigator öffnen"),
  };
  const label = labels[target];
  return <button type="button" className="treeMenuIcon navigatorBranchButton"
    data-testid={"navigation-open-" + target} title={label} aria-label={label}
    onMouseDown={event => { if (event.button === 0) { event.preventDefault(); event.stopPropagation(); } }}
    onClick={event => { event.preventDefault(); event.stopPropagation(); onOpen(target); }}>
    <i className="las la-columns" aria-hidden="true" />
  </button>;
}
